<template>
  <div id="app">
    <head-Back title = '联系客服'></head-Back>
    <div class="page">
      <div class="page-log">
        <img src="./img/kf.jpg" alt />
        <p>好运吧客服微信</p>
      </div>

      <div class="page-button">
        <button class="page-button-left" @click="downs()">点击保存二维码</button>
        <button
          class="page-button-right"
          v-clipboard:copy="invitationCode"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
        >复制客服微信号</button>
      </div>

      <div class="page-foot">
        <p>如何联系客服？</p>
        <p>1、添加客服微信</p>
        <p>2、在伪装APP中联系APP客服</p>
      </div>
    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back";
import tips from "@/estoast";

export default {
  name: "app",
  metaInfo: {
    title: "联系客服"
  },
  data() {
    return {
      msg: "注册协议",
      invitationCode: "Zzzzzzzzzz0320"
    };
  },
  methods: {
    onCopy(e) {
      console.log(e);
      tips.toast("已复制，快去微信添加客服吧！");
    },
    onError(e) {
      console.log(e);
      tips.toast("复制失败");
    },
    downs() {
      
      //判断微信环境
      var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            tips.toast("长按识别二维码");
            return
        }

      this.downloadIamge("http://img.haoyunba.com/kf.jpg", "pic");
      tips.toast("已保存至手机相册");
    },
    downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function() {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    }
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
.page {
  width: 750px;
  height: 1344px;
  min-height: 100%;
  background: url("../../assets/img/login-bj@2x.png");
  overflow: hidden;
  background-size: 100% 100%;
}
.page-log {
  width: 326px;
  height: 380px;
  margin: 72px auto 0px;
}

.page-log img {
  height: 304px;
  widows: 326px;
}
.page-log p {
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #ffffff;
  text-align: center;
}

.page-button {
  width: 600px;
  margin: 88px auto 0px;
}

.page-button button {
  border: none;
  background: linear-gradient(180deg, #2d50ed 0%, #4ea0fe 100%);
  border-radius: 4px;
  border-radius: 4px;
  border: 0px;
  height: 72px;
  width: 260px;
  font-family: PingFangSC-Medium;
  font-size: 28px;
  color: #ffffff;
  letter-spacing: 0.26px;
  text-align: center;
 
}

.page-button-left {
  float: left;
}
.page-button-right {
  float: right;
}

.page-foot {
  margin: 360px 0 0 76px;
}
.page-foot p {
  font-size: 24px;
  font-family: PingFangSC-Regular;
  color: #7a7c87;
  letter-spacing: -0.07px;
  text-align: left;
}

</style>


// WEBPACK FOOTER //
// src/components/contact/contactKF.vue